import { SignUpFormData } from '@/contexts/forms/SignUp';
import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY = 'signup-form-data';
const KEY_MKTAG = 'marketing-tag-body';

export const formDataSessionStorage = CustomSessionStorage<SignUpFormData>(KEY);

export const mktagSessionStorage = CustomSessionStorage<string>(KEY_MKTAG);
